<div class="col px-lg-5 px-2">
	<app-nav-parametrage
		class="row py-5"
		[addable]="isAddable"
		(addEvent)="openModalAjout()"
		[isImportable]="isImportable"
		(importingEvent)="uploader.click()"
	></app-nav-parametrage>

	<input hidden type="file" #uploader (change)="importNiveauQualification($event)" />

	<div class="my-3">
		<div class="row my-2">
			<div class="col-lg-3 col-12 ms-lg-auto">
				<div class="input-group">
					<span class="input-group-text bg-transparent"
						><i class="bi bi-search" aria-hidden="true"></i
					></span>
					<input
						type="text"
						class="form-control border-start-0"
						placeholder="Recherche un élément..."
						[(ngModel)]="searchedText"
					/>
				</div>
			</div>
		</div>

		<div class="mt-4" *ngIf="isListingLoading">
			<app-loading></app-loading>
		</div>

		<div *ngIf="!isListingLoading" class="row mt-4">
			<div
				*ngFor="
					let taux of niveauQualification
						| filterNiveauQualificationByName: searchedText
						| paginate
							: {
									itemsPerPage: itemsPerPage,
									currentPage: currentPage
							  };
					odd as isOdd
				"
				profile="button"
				(click)="openModalEdit(taux)"
				class="col-lg-5 col-12 text-center spec my-1 py-3 rounded rounded-3 bg-light"
				[ngClass]="{ 'offset-2': isOdd && !isMobile }"
			>
				<span class="col">{{ taux.name }}</span>
			</div>
		</div>

		<div class="row my-4">
			<pagination-controls
				class="d-flex justify-content-center"
				(pageChange)="currentPage = $event"
				previousLabel="Précédent"
				nextLabel="Suivant"
			>
			</pagination-controls>
			<div class="d-flex justify-content-center">
				<label class="form-label mt-2 mx-2">Elements par page</label>
				<div class="">
					<select
						[(ngModel)]="itemsPerPage"
						#ctrl="ngModel"
						(change)="currentPage = 1"
						[ngModelOptions]="{ standalone: true }"
						class="form-select"
					>
						<option [value]="6">6</option>
						<option *ngIf="niveauQualification?.length >= 6" [value]="10">10</option>
						<option *ngIf="niveauQualification?.length >= 10" [value]="26">26</option>
						<option *ngIf="niveauQualification?.length >= 26" [value]="50">50</option>
						<option *ngIf="niveauQualification?.length >= 50" [value]="100">100</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>
